import { Stack } from '@mui/material';
import { UploadDetail } from '../../../../services/entities/impl/blfApi/schemas/uploadSummary';
import { UploadDetailListItem } from './UploadDetailListItem';

export const UploadDetailList = ({
  uploadDetails,
}: {
  uploadDetails: UploadDetail[];
}) => {
  return (
    <Stack spacing={2}>
      {uploadDetails.map((val, idx) => {
        return (
          <UploadDetailListItem
            uploadDetail={val}
            key={`${val.collectionID}-index:${idx}`}
          />
        );
      })}
    </Stack>
  );
};
